export var ELegalCaseStatus;
(function (ELegalCaseStatus) {
    ELegalCaseStatus["Open"] = "open";
    ELegalCaseStatus["Closed"] = "close";
})(ELegalCaseStatus || (ELegalCaseStatus = {}));
